export default "__VITE_ASSET__DLsqHHYF__"